import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { BRAND, NAV_LINKS } from "@/lib/brand";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "glass-header" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 flex items-center justify-between h-20">
        <a
          href="#top"
          data-testid="header-logo"
          className="flex items-center gap-2 group"
        >
          <span className="font-serif text-2xl tracking-tight text-[#3B2A22] group-hover:text-[#B88746] transition-colors">
            The Best <span className="italic text-[#B88746]">Bronze</span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.href.replace("#", "")}`}
              className="text-sm font-medium tracking-wide text-[#3B2A22] hover:text-[#B88746] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex">
          <a href="#rezervare" data-testid="header-cta-book" className="btn-primary">
            Programează-te
          </a>
        </div>

        <button
          aria-label="Deschide meniul"
          data-testid="mobile-menu-toggle"
          className="lg:hidden p-2 text-[#3B2A22]"
          onClick={() => setOpen(!open)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-nav"
          className="lg:hidden glass-header border-t border-[#D7B899]/30"
        >
          <div className="px-6 py-6 flex flex-col gap-4">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-sm font-medium text-[#3B2A22] hover:text-[#B88746] py-2"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#rezervare"
              onClick={() => setOpen(false)}
              className="btn-primary mt-2"
            >
              Programează-te
            </a>
            <div className="text-xs text-[#8A6E59] pt-2 border-t border-[#D7B899]/40 mt-2">
              {BRAND.phone}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
